"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Takes a base64 value as a string and converts it to an array buffer
 * @param base64 string
 */
var base64ToArrayBuffer = function (base64) {
    var binaryString = window.atob(base64);
    var len = binaryString.length;
    var bytes = new Uint8Array(len).map(function (_, index) {
        return binaryString.charCodeAt(index);
    });
    return bytes.buffer;
};
/**
 * Takes a base64 value as a string and converts it to an array buffer
 * Creates a Uint8Array from that buffer to be used by the
 * open-policy-agent/opa-wasm package
 * @param base64 string
 * @returns Uint8Array
 */
exports.processWasmPolicy = function (base64) {
    var buffer = base64ToArrayBuffer(base64);
    return new Uint8Array(buffer);
};
